<template>
  <div class="collapse-container" :class="{ white }">
    <div class="collapse-item">
      <div
        class="collapse-title"
        :class="{
          'is-loading': isLoading,
          disable,
          'collapse-title--has-right': $scopedSlots.titleRight,
        }"
        :style="{ padding: titlePadding }"
        @click="$_onToggleCollapse"
      >
        <LvFlexBox noWrap>
          <i
            v-if="isCollapseIconLeft && isCollapsable && collapseActive"
            class="collapse-icon icon-unfold-less mr-4"
          />
          <i
            v-else-if="isCollapseIconLeft && isCollapsable"
            class="collapse-icon icon-unfold-more mr-4"
          />
          <LvText
            v-if="title"
            h5
            bold
            :blue="!white"
            :bgYellow="isHighlight"
            class="collapse-title-text"
          >
            {{ $t(title) }}
          </LvText>
          <LvFlexBox v-if="chipList && chipList.length">
            <ContentChip
              v-for="(chip, chipIndex) in chipList"
              :key="chipIndex"
              noWrap
              :class="{ 'ml-8': chipIndex === 0, 'mr-8': chipIndex !== chipList.length - 1 }"
              :color="chip.color ? chip.color : 'yellow'"
              :textLabel="chip.text"
            />
          </LvFlexBox>
        </LvFlexBox>
        <div v-if="$scopedSlots.titleRight" class="collapse-title__right">
          <slot name="titleRight" />
        </div>
        <LvFlexBox noWrap>
          <WsButton001
            v-for="(btn, btnIndex) in customBtnList"
            :key="`btn-${btnIndex}`"
            outLine
            flatButton
            shortButton
            :disable="disable"
            :isloading="loadingBtnEvent === btn.event"
            @click="$emit('click-btn', btn.event)"
          >
            {{ $t(btn.text) }}
          </WsButton001>
          <IconButton
            v-for="(btn, btnIndex) in customIconBtnList"
            :key="`icon-btn-${btnIndex}`"
            :icon="btn.icon"
            :color="btn.color"
            :disabled="disable"
            :tooltipText="btn.tooltipText"
            @click="$emit('click-icon', btn.event)"
          />
          <i
            v-if="!isCollapseIconLeft && isCollapsable && collapseActive"
            class="collapse-icon icon-unfold-less ml-20"
          />
          <i
            v-else-if="!isCollapseIconLeft && isCollapsable"
            class="collapse-icon icon-unfold-more ml-20"
          />
        </LvFlexBox>
      </div>
      <slide-up-down :active="collapseActive" :duration="300">
        <div v-if="collapseActive" class="collapse-content" :style="{ padding: contentPadding }">
          <slot name="cardLists" />
        </div>
      </slide-up-down>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CollapseContainer',
  props: {
    title: {
      type: String,
      default() {
        return this.$t('相關文件');
      },
    },
    white: {
      type: Boolean,
      default: false,
    },
    isCollapsable: {
      type: Boolean,
      default: true,
    },
    customIconBtnList: {
      type: Array,
    },
    chipList: {
      type: Array,
    },
    isCollapseIconLeft: {
      type: Boolean,
      default: false,
    },
    contentPadding: {
      type: String,
    },
    titlePadding: {
      type: String,
    },
    isHighlight: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    customBtnList: {
      type: Array,
    },
    loadingBtnEvent: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    collapseActive: false,
  }),
  methods: {
    $_onToggleCollapse($event) {
      if (
        this.disable ||
        this.isLoading ||
        !this.isCollapsable ||
        ($event.target !== $event.currentTarget &&
          !$event.target.classList.contains('collapse-icon') &&
          !$event.target.classList.contains('collapse-title-text'))
      )
        return;
      this.collapseActive = !this.collapseActive;
      this.$emit('toggle-collapse', this.collapseActive);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/collapse-container';
</style>
